<template>
    <div class="buygb">
    <div class="buyl">
        <h4>卖家权益</h4>
        <ul>
            <li>
                只要您是合法经营的医药公司，<br>
                在药聚多获得注册认证后，可以享受以下服务：
                <br>
                <span class="blue1"><img src="@/assets/quan.png" style="width:15px;height:15px;">&nbsp;&nbsp;</span>在药聚多平台出售合法经营的商品<br>
                <span class="blue1"><img src="@/assets/quan.png" style="width:15px;height:15px;">&nbsp;&nbsp;</span>平台内的品牌广告、活动宣传<br>
                <span class="blue1"><img src="@/assets/quan.png" style="width:15px;height:15px;">&nbsp;&nbsp;</span>获得更多潜在客户<br>
            </li>
        </ul>
    </div>
    <reg-view name="卖家"></reg-view>
    <div class="clear"></div>
</div>
</template>
<script>
import RegView from './components/RegView.vue'
export default {
  name: 'Saler',
  components: { RegView }
}
</script>
